import React, { Fragment, Component } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import ProductTable from "./components/table";
import ProductService from "../../../services/productService";

import BrandCategoryService from "../../../services/brandCategoryService";
import DateRangePicker from "../../../components/common/dateRangePicker";
import Search from "../../../components/common/search";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import $ from "jquery";
// import store from "store";

class CreateDealer extends Component {
  state = {
    infoData: [],
    brandsList: [],
    categoryList: [],
    page: 0,
    pageSize: 10,
    totalRecords: 0,
    loading: false,
  };

  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { productStatus } = params;
    this.setState({ loader: true, productStatus }, function () {
      BrandCategoryService.fetchBrandCategoryInfo().then((response) => {
        if (!response.error) {
          this.setState(
            {
              loader: true,
              brandsList: response?.data?.brandList,
              categoryList: response?.data?.categoryList,
            },
            function () {
              this.callApiInfo();
            }
          );
        }
      });
    });
  }

  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { productStatus } = params;
    if (this.state.productStatus !== productStatus) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          productStatus: productStatus,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }

  callApiInfo = () => {
    const {
      productStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate,
    } = this.state;

    ProductService.fetchProductsInfo(
      undefined,
      productStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate
    ).then((response) => {
      if (!response.error) {
        var totalRecords = Math.ceil(response?.data?.totalRecords / pageSize);
        console.log({ response: response.data });
        this.setState({
          modalFormShow: false,
          loader: false,
          infoData: response?.data?.products,
          totalRecords: totalRecords,
        });
      } else {
        this.setState({
          loader: false,
          infoData: [],
          totalRecords: 0,
        });
      }
    });
    this.setState({ loader: false });
  };

  onChangeActive = (productId, value, index) => {
    console.log({ productId, value });
    const { infoData } = this.state;
    this.setState({ loader: true });
    ProductService.onProductReady(productId, value).then((response) => {
      if (!response.error) {
        infoData[index].public = value;
        this.setState({ infoData, loader: false });
        // this.props.history.push("/products/all");
      }
      this.setState({ loader: false });
    });
  };
  // addBrandForm = (data) => {
  //   this.setState({ loader: true });
  //   DealerService.addDealerInfo(data).then((response) => {
  //     if (!response.error) {
  //       this.props.history.push("/dealer/inbox");
  //     }
  //     // //console.log("response", response[0] === "{");
  //     // toast.success("List fetched successfully!");
  //     // if (response[0] === "{") {
  //     //   this.setState({ infoData: [JSON.parse(response)] });
  //     // } else if (response[0] === "[") {
  //     //   this.setState({ infoData: JSON.parse(response) });
  //     // } else {
  //     //   this.setState({ infoData: [] });
  //     // }
  //   });
  // };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };

  onSearchText = (searchText) => {
    this.setState(
      {
        page: 0,
        searchText: searchText,
        startDate: "",
        endDate: "",
      },
      function () {
        // if (searchText && searchText !== "" && searchText.length > 0) {
        $.ajaxQ.abortAll();
        this.callApiInfo();
        // }
      }
    );
  };

  onSearchDate = (startDate, endDate) => {
    this.setState(
      {
        page: 0,
        searchText: "",
        startDate: startDate,
        endDate: endDate,
      },
      function () {
        if (startDate && endDate) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onChangePageSize = (pageSize) => {
    this.setState(
      {
        pageSize: pageSize,
      },
      function () {
        if (pageSize) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };

  onChangePage = (page) => {
    this.setState(
      {
        page: page,
      },
      function () {
        $.ajaxQ.abortAll();
        this.callApiInfo();
      }
    );
  };
  
  render() {
    const {
      productStatus,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      brandsList,
      categoryList,
    } = this.state;

    console.log(this.state)
    const { loading, page, pageSize, totalRecords } = this.state;
    
    const propsDaterangePicker = {
      changeRangePicker: (startDate, endDate) => {
        this.onSearchDate(startDate, endDate);
      },
    };

    const propsSearchText = {
      searchText: this.state.searchText,
      onChangeText: (searchText) => {
        this.onSearchText(searchText);
      },
    };

    const propsTable = {
      brandsList,
      categoryList,
      loader: loader,
      selectedIndex: index,
      productStatus: productStatus,
      multiSelectOption: false,
      myData: infoData,
      loading: loading,
      pageSize: pageSize,
      page: page,
      totalRecords: totalRecords,
      // pageSize: infoData.length < 10 ? infoData.length : 10,
      pagination: true,
      onChangeActive: this.onChangeActive,
      onEditBrandInfo: (index, info) => {
        // this.setState({ modalFormShow: true, isEdit: true, info });
        this.props.history.push("/products/" + info._id + "/update");
      },
      onChangePageSize: (pageSize) => {
        //console.log({ pageSize });
        this.onChangePageSize(pageSize);
      },
      onChangePage: (page) => {
        this.onChangePage(page);
      },
      deactivateMember: (staffMemberId) => {
        // this.memberDeactivate(staffMemberId);
      },
      handleInfoEdit: (info) => {
        //console.log({info})
        // this.dealerInfoEdit(info);
      },
    };

    return (
      <Fragment>
        <Breadcrumb title={productStatus} parent="Product" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{boxShadow:"1px 5px 24px 0 rgba(68, 102, 242, .05)"}}>
                {/* <div className="card-header">
                  <h5>Select Multiple Data</h5>
                </div> */}

                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}
                <div className="card-body datatable-react" style={{padding:"30px"}}>
                  <div className="row m-b-10">
                    <div className="col-sm-4">
                      <Button
                        className="btn btn-danger"
                        onClick={() => this.props.history.push("/products/add")}
                      >
                        Add New Product
                      </Button>{" "}
                    </div>
                    <div className="col-sm-4">
                      {/* <Search {...propsSearchText} /> */}
                    </div>

                    <div className="col-sm-4" style={{ marginTop: "10px" }}>
                      {/* <DateRangePicker {...propsDaterangePicker} /> */}

                      <Search {...propsSearchText} />
                    </div>
                  </div>
                  {/* {infoData && infoData.length > 0 && ( */}
                  <ProductTable
                    {...propsTable}
                    className="-striped -highlight"
                  />
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalFormShow}
          toggle={() => this.onClickToggle()}
          size="lg"
        // style={{ width: "80%", maxWidth: "90%" }}
        >
          <ModalHeader toggle={() => this.onClickToggle()}>
            {"Edit Product"}
          </ModalHeader>
          <ModalBody>{/* <BrandForm {...brandFormProps} /> */}</ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default CreateDealer;
